import { imgSearchForCheckSumsPostApi } from '../api/sip';
import fetchImages from './fetchImages';
export default async (body, logger) => {
    const checksumsForImageSearch = await imgSearchForCheckSumsPostApi(body);
    if (checksumsForImageSearch[1].length === 0) {
        return [];
    }
    else {
        const checkumCollection = checksumsForImageSearch[1];
        return fetchImages(checkumCollection);
    }
};
